import _ from 'lodash';

export function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
export function getRandomRGBColor() {
  const r = Math.floor(Math.random() * 256);
  const g = Math.floor(Math.random() * 256);
  const b = Math.floor(Math.random() * 256);
  return `rgb(${r}, ${g}, ${b})`;
}

export function getNameBasedOnNameSearch(name_search, value) {
  const text = _.get(value, name_search);
  console.log(text); // Output: 'USA'
  return text
}


function isLikelyEnGBDate(dateStr) {
  const parts = dateStr.split(' ')[0]?.split('/');
  if (!parts || parts.length !== 3) return false;

  const [day, month, year] = parts.map(Number);

  return (
    day >= 1 && day <= 31 &&
    month >= 1 && month <= 12 &&
    year >= 1000 && year <= 9999 &&
    day > 12 // This helps reduce false matches with MM/DD/YYYY
  );
}

export function formatDateTimeIn(dateStr) {
  // If already in 'dd/mm/yyyy hh:mm AM/PM' — just return
  // if (/^\d{2}\/\d{2}\/\d{4}/.test(dateStr)) return dateStr;
  if (isLikelyEnGBDate(dateStr)) return dateStr;

  const dateObj = new Date(dateStr);
  if (isNaN(dateObj.getTime())) return dateStr; // invalid date fallback

  return dateObj.toLocaleString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
}

export function timeAgo(date) {
  const now = new Date();
  const diffMs = now - new Date(date); // difference in milliseconds

  const seconds = Math.floor(diffMs / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (seconds < 60) return `${seconds}s ago`;
  if (minutes < 60) return `${minutes}m ago`;
  if (hours < 24) return `${hours}h ago`;
  if (days < 30) return `${days}d ago`;

  // fallback to date format if > 30 days
  return new Date(date).toLocaleDateString();
}

export function isEmailAddress(email) {
  const reg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return reg.test(email);
}
